import { Component, ReactNode } from 'react'
import AnalyticsHelper from 'utils/AnalyticsHelper'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
}

class ComponentErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true }
  }

  public componentDidCatch(error: Error) {
    AnalyticsHelper.trackEvent('Server Error on Dashboard - component', {
      stack: error.stack
    })
  }

  public render() {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}

export default ComponentErrorBoundary
